
import React, { BaseSyntheticEvent, useState, useEffect } from 'react';
import { CQAppConstant } from '../../../../../app-constants';
import { observer } from 'mobx-react';
import LayoutFieldsConfigController from '../../../layout-level-fields.controller';
import { IFormulaFieldsRuleModalProps, IFormulaRuleModalState, ICoreRule, ICriteria } from '../../ILayoutConfigurationPanel.Interface';
import '../apply-rule-modal.css';
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import { CommonRuleModal } from '././../common-rule-modal';
import { Utility } from './../../../../../common/utility';

interface IFormulaCoreRule {
    setObject:ICoreRule[],
}

interface IFormulaExtendedRule {
    type:string,
    additionalFields: string[];
    fieldWisePicklistValues: any[];
    selectedReferenceFields: any[];
}

const INITIAL_STATE = {
    field: '',
    operator: '',
    compareTo: '',
    isDynamic: false,
    selectedFieldType: '',
    referenceField: '',
    referenceTo: '',
    relationshipName: ''
}

const INITIAL_ACTION = {
    value: '',
    text: '',
    target: "'_blank'"
}

const cqUtility = new Utility();
const layoutFieldsConfigCtrl = new LayoutFieldsConfigController();
const FormulaFieldRuleModalComponent = (props: IFormulaFieldsRuleModalProps) => {
    const [state, setState] = useState<IFormulaCoreRule>(() => ({
        setObject: [
            {
                addedCriterias: [INITIAL_STATE],
                action: INITIAL_ACTION,
                complexLogicQuery: '1',
                complexLogicVisibility: false,
                shouldSkip: false
            }
        ]
    }));
    const [extraState, setExtraState] = useState<IFormulaExtendedRule>(() => ({
        type: props.selectedFormulaType,
        additionalFields: [],
        selectedReferenceFields: [],
        fieldWisePicklistValues: []
    }));

    const [shouldValidate, setShouldValidate] = useState(false);

    useEffect(() => {
        async function initializeStates() {
            if (props.appliedRule) {
                const ruleObject = CQMasterDataStore.RuleElements.FieldRuleElement;
                const objectName: any = props.objectName;
                const ruleElement = { ...(ruleObject[objectName])[props.appliedRule] };
                const selectedObjectName = CQMasterDataStore.OutputConfig.getStoreKeyData(props.selectedTemplateName, 'selectedObject');
                if (ruleElement) {
                    let selectedReferenceFields: any[] | undefined = [];
                    let fieldWisePicklistValues = ruleElement.fieldWisePicklistValues;
                    if (ruleElement.selectedReferenceFields) {
                        selectedReferenceFields = await layoutFieldsConfigCtrl.getLookFieldsDataInEditMode(ruleElement.selectedReferenceFields);
                        selectedReferenceFields = (selectedReferenceFields && selectedReferenceFields.length > 0) ? selectedReferenceFields : [];
                    }
                    if (ruleElement.fieldWisePicklistValues) {
                        fieldWisePicklistValues = await layoutFieldsConfigCtrl.getPickListValueDataInEditMode(selectedObjectName, ruleElement.fieldWisePicklistValues);
                        fieldWisePicklistValues = (fieldWisePicklistValues && fieldWisePicklistValues.length > 0) ? fieldWisePicklistValues : [];
                    }
                    setState({
                        setObject: ruleElement.setObject,
                        
                    });
                    
                    setExtraState({
                        type: ruleElement.type,
                        additionalFields: ruleElement.additionalFields,
                        selectedReferenceFields,
                        fieldWisePicklistValues
                    })
                }
            }
        }
        initializeStates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        updateRuleObject(CQAppConstant.ADDED_CRITERIAS, generateMergedStore());
        props.checkValidation(validateAddRuleForm());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    useEffect(() => {
        updateRuleObject(CQAppConstant.ADDED_CRITERIAS, generateMergedStore());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [extraState]);

    function generateMergedStore():IFormulaRuleModalState {
        return {...state, ...extraState};
    }

    /**
     * @description sets the validation boolean to true if false
     */
     const setValidation = () => {
        if(!shouldValidate){
            setShouldValidate(true);
        }
    }

    /**
     * @private
     * @memberof FormulaFieldRuleModalComponent
     */
    const onActionTextChanged = (e: BaseSyntheticEvent, fieldSectionIndex: number) => {
        setValidation();
        const stateCopy = cqUtility.createObjectDeepCopy(state);
        stateCopy.setObject[fieldSectionIndex].action.text = e.target.value;
        setState( stateCopy )
        updateRuleObject(CQAppConstant.COMPLEX_LOGIC, stateCopy);
    }

    /**
     * @private
     * @memberof FormulaFieldRuleModalComponent
     */
    const onActionValueChanged = (e: BaseSyntheticEvent, fieldSectionIndex: number) => {
        setValidation();
        const stateCopy = cqUtility.createObjectDeepCopy(state);
        stateCopy.setObject[fieldSectionIndex].action.value = e.target.value;
        setState( stateCopy )
        updateRuleObject(CQAppConstant.COMPLEX_LOGIC, stateCopy);
    }

    /**
  * @private
  * @memberof FormulaFieldRuleModalComponent
  */
    const addSetObjectSection = () => {
        setValidation();
        const stateCopy = cqUtility.createObjectDeepCopy(state);
        const setObjectSection = {
            addedCriterias: [{
                field: '',
                operator: '',
                compareTo: '',
                isDynamic: false,
                selectedFieldType: '',
                referenceField: '',
                referenceTo: '',
                relationshipName: ''
            }
            ],
            action: {
                value: '',
                text: '',
                target: "'_blank'"
            },
            complexLogicQuery: '1',
            complexLogicVisibility:false,
            shouldSkip: false
        };
        stateCopy.setObject.push(setObjectSection);
        setState( stateCopy );
        updateRuleObject(CQAppConstant.SET_OBJECTS, stateCopy)
    }

    /**
    * @private
    * @memberof FormulaFieldRuleModalComponent
    */
    const deleteRule = (fieldSectionIndex: number) => {
        const stateCopy = cqUtility.createObjectDeepCopy(state);
        const extraStateCopy = cqUtility.createObjectDeepCopy(extraState);
        extraStateCopy.additionalFields = removeAllAdditionalFields(fieldSectionIndex);
        let setObject = stateCopy.setObject.filter((setObjectSection: any, index: number) => index !== fieldSectionIndex);
        stateCopy.setObject = setObject;
        setState( stateCopy) 
        setExtraState( extraStateCopy );
        updateRuleObject(CQAppConstant.SET_OBJECTS, stateCopy)
    }

    /**
     * @private
     * @memberof FormulaFieldRuleModalComponent
     */
    const updateRuleObject = (ruleObjectProperty: string, ruleObjectValue: any) => {
        props.setRuleObject(ruleObjectValue);
        props.checkValidation(validateAddRuleForm());
    }


    /**
     * @private
     * @returns {boolean} If state are valid then returns false else true
     * @memberof FormulaFieldRuleModalComponent
     */
    const validateAddRuleForm = () => {
        if (!shouldValidate) {
            return true;
        } 
        let isComplexLogicValid = false;
        let isCriteriaValid = false;
        state.setObject && state.setObject.forEach((fieldOperatorSection: any) => {
            isCriteriaValid = fieldOperatorSection.addedCriterias.every((criteria: ICriteria, index: number) => (
                criteria.field !== ''
                && criteria.operator !== ''
                && ((CQAppConstant.REFERENCE_FIELD_TYPE).includes(criteria.selectedFieldType) ?
                    ((criteria.operator === CQAppConstant.EXISTS || criteria.operator === CQAppConstant.ISEMPTY || index === 0) ? true :
                        (criteria.referenceField !== '')) : true)));

            if(fieldOperatorSection.shouldSkip){
                isCriteriaValid = true;
            }

            isComplexLogicValid = (fieldOperatorSection.complexLogicQuery === '');
        });
        if (!isCriteriaValid || isComplexLogicValid) {
            return true;
        }
        return false;
    }

    /**
    * @private
    * @memberof FormulaFieldRuleModalComponent
    */

    const removeAllAdditionalFields = (fieldSectionIndex: number) => {
        const setObject = [...state.setObject];
        let additionalFields = [...extraState.additionalFields];
        let fields = setObject[fieldSectionIndex].addedCriterias.map((criteria: any) => criteria.field);
        fields = [...fields, ...setObject[fieldSectionIndex].addedCriterias.map((criteria: any) => criteria.compareTo)];

        fields.forEach((fieldName: string) => {
            additionalFields = additionalFields.filter((additionalField: string) => additionalField !== fieldName);
        });
        return additionalFields;
    }

    /**
     * @description Used to set validation true for new states
     * @param newState contains state copy
     */
    function updateState (newState: IFormulaCoreRule) {
        setValidation();
        setState(newState);
    }

    return(
        <>
            
            <React.Fragment>
                <div className="slds-grid slds-grid_vertical">
                    {
                        state.setObject && state.setObject.map((fieldOperatorSection: any, fieldSectionIndex: number) => {
                            return (
                                <React.Fragment key={`setobject ${fieldSectionIndex}`}>
                                    <div className="slds-grid slds-grid_vertical formulaFieldFieldOperatorGrid">
                                        <div className="slds-grid slds-grid_align-spread slds-grid_vertical-align-center slds-m-bottom_small">
                                            <h2>{`Rule ${fieldSectionIndex + 1}`} </h2>
                                            {fieldSectionIndex !== 0 &&
                                                <button className="slds-button slds-button_icon slds-button_icon-border-filled" onClick={() => {
                                                    deleteRule(fieldSectionIndex);
                                                }}>
                                                    <i className="cq-icon-delete"></i>
                                                </button>
                                            }
                                        </div>
                                        <CommonRuleModal
                                            modalInfo= {{
                                                shouldRenderAddComplexBtn: true,
                                                shouldDisableFirstElement: false,
                                                toggleModalVisibility: props.toggleModalVisibility
                                            }}
                                            parentAction= {{
                                                updateState: (state: any) => updateState(state),
                                                updateExtraState: (state: any) => setExtraState(state)
                                            }}
                                            parentInfo= {{
                                                state:state.setObject,
                                                extraState,
                                                initialCriteria: INITIAL_STATE,
                                                sectionIndex: fieldSectionIndex,
                                                addFieldOnSkip: true,
                                            }}
                                            objectName= {props.objectName}
                                            templateName= {props.selectedTemplateName}
                                            selectedRule='setObject'
                                        />

                                        <h3 className="slds-text-heading_small slds-m-bottom_small">Set Action</h3>
                                        <div className="slds-grid slds-gutters_x-small">
                                            <div className="slds-col slds-size_4-of-12 slds-form-element">
                                                <label className="slds-form-element__label">Action Text</label>
                                                <div className="slds-form-element__control">
                                                    <input type="text" id="text-input-id-1"
                                                        value={fieldOperatorSection.action.text}
                                                        onChange={e => onActionTextChanged(e, fieldSectionIndex)} placeholder="Placeholder Text" className="slds-input" />
                                                </div>
                                            </div>
                                            <div className="slds-col slds-size_8-of-12 slds-form-element">
                                                <label className="slds-form-element__label">Action Value</label>
                                                <div className="slds-form-element__control">
                                                    <input type="text" id="text-input-id-1"
                                                        value={fieldOperatorSection.action.value}
                                                        onChange={e => onActionValueChanged(e, fieldSectionIndex)} placeholder="Placeholder Text" className="slds-input" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="slds-border_bottom slds-m-vertical_small"></div>
                                </React.Fragment>
                            );
                        })
                    }
                </div>
                <div className="slds-grid_absolute-center">
                    <button className="slds-button slds-button_neutral slds-m-top_x-small" onClick={addSetObjectSection}>Add formula field rule</button>
                </div>
            </React.Fragment>
        </>
    );
}
export const FormulaFieldsModal = observer(FormulaFieldRuleModalComponent);
